
class DateUtils {
    static formatDate = (myNumber) => {
		if(Number(myNumber) < 10)
			return ("0" + myNumber).slice(-2)
		return myNumber;
    }
    
    static getDaysInMonth = (month, year) => {
		return new Date(year, month, 0).getDate();
	}
}

export default DateUtils;